import type { ReactNode } from 'react'

import { ResizeHandle } from '@/components/ui/resize-handle.atom'
import type { useDraftAgencyPreviewChat } from '@/hooks/use-draft-agency-preview-chat.hook'
import { cn } from '@/lib/utils'
import { AgencyPreviewChatContent } from './agency-preview-chat-content.atom'
import { AgencyPreviewChatHeader } from './agency-preview-chat-header.atom'
import { AgencyPreviewChatTrigger } from './agency-preview-chat-trigger.atom'

interface AgencyPreviewChatDesktopProps {
  state: ReturnType<typeof useDraftAgencyPreviewChat>['state']
  handlers: ReturnType<typeof useDraftAgencyPreviewChat>['handlers']
  conversationId: string | null
  onResize: (deltaX: number) => void
  className?: string
}

export const AgencyPreviewChatDesktop = ({
  state,
  handlers,
  conversationId,
  onResize,
  className,
}: AgencyPreviewChatDesktopProps): ReactNode => {
  if (!state.isOpen) {
    return <AgencyPreviewChatTrigger onClick={handlers.handleOpen} className={className} />
  }

  return (
    <div
      className={cn(
        'agency-preview-chat-panel flex h-full border-l bg-background',
        'animate-in slide-in-from-right duration-200',
        className
      )}
      style={{ width: state.panelWidth }}
    >
      <ResizeHandle onResize={onResize} className="shrink-0" />
      <div className="flex flex-1 flex-col overflow-hidden">
        <AgencyPreviewChatHeader onClose={handlers.handleClose} onReset={handlers.handleReset} />
        <div className="flex-1 overflow-hidden">
          <AgencyPreviewChatContent
            state={state}
            handlers={handlers}
            conversationId={conversationId}
          />
        </div>
      </div>
    </div>
  )
}

AgencyPreviewChatDesktop.displayName = 'AgencyPreviewChatDesktop'
